module.exports = __webpack_public_path__ + "img/1df134d.jpg";